import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles/ExpandedMediaModal.css'

const ExpandedMediaModal = ({ url, handleExpandedMessage, isPatientsPage }) => {
  const closeExpandedPhoto = () => { handleExpandedMessage(null) }
  const mediaBgStyle = {
    backgroundImage: `url(${url})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '100%',
    width: '100%',
  }


  return (
    <div
      className={styles.outerWrapper}
      onClick={closeExpandedPhoto}
    >
      <div
        className={styles.closeButton}
      >
      x
      </div>
      <div className={styles.greyBg}>
        <div style={mediaBgStyle} />
      </div>
    </div>
  )
}

ExpandedMediaModal.propTypes = {
  url: PropTypes.string.isRequired,
  handleExpandedMessage: PropTypes.func.isRequired,
  isPatientsPage: PropTypes.bool,
}

export default ExpandedMediaModal



// WEBPACK FOOTER //
// ./src/components/Messages/ExpandedMediaModal.js